import React from "react";
import { Route } from "react-router-dom";
import RouteWrapper from "./RouteWrapper";

import { EmptyPage } from "../pages/EmptyPage";
import BemVindo from "../pages/BemVindo/";

/*MÓDULO SEGURANÇA*/
import Usuarios from "../pages/seguranca/usuarios";
import Usuario from "../pages/seguranca/usuarios/usuario";
import PerfilUsuario from "../pages/perfil";

/*MÓDULO MONITORAMENTO*/
import MonitoraLancamentos from "../pages/monitora/lancamentos";
import MonitoraPermissoes from "../pages/monitora/permissoes";
import MonitoraCadastroExercicios from "../pages/monitora/exercicios";
import RelatorioBaseGeral from "../pages/monitora/relatorios/relatorioBaseGeral";
import RelatorioExecucaoFisicaSintetico from "../pages/monitora/relatorios/relexecfisicasintetico";
import RelatorioExecucaoFisicaAnalitico from "../pages/monitora/relatorios/relexecfisicaanalitico";
import RelatorioPermissoes from "../pages/monitora/relatorios/relpermissoes";
import RelatorioStatusExecucao from "../pages/monitora/relatorios/relstatusexecucao";
import RelatorioRestricaoItensMonitoraveis from "../pages/monitora/relatorios/relatorioRestricaoItensMonitoraveis";
import RelatorioExecucaoFinanceiraAnalitico from "../pages/monitora/relatorios/relatorioFinanceiroAnalitico";
import RelatorioExecucaoFinanceiraSintetico from "../pages/monitora/relatorios/relatorioFinaceiroSintetico";
import CadastroCiclo from "../pages/monitora/exercicios/ciclo/";
import RelatorioConsolidadoMonitoramento from "../pages/monitora/relatorios/relatorioMonitoraConsolidado";

import RelatorioIndicadoresAcao from "../pages/monitora/relatorios/relatorioIndicadoresAcao";

/*MÓDULO RAG*/
import RagLancamentos from "../pages/rag/lancamentos";
import AvaliacaoAcaoRag from "../pages/rag/lancamentos/avaliacaoacao";
import AvaliacaoProgramaRag from "../pages/rag/lancamentos/avaliacaoprograma";
import RagPermissoes from "../pages/rag/permissoes";
import RelatorioConsolidado from "../pages/rag/relatorios/relatorioconsolidado";
import RelatorioConsolidadoPorProgramaAcao from "../pages/rag/relatorios/relatorioconsolidadoprogacao";
import RelatorioExecucaoOrcamentaria from "../pages/rag/relatorios/RelatorioExecucaoOrcamentaria";
import RelatorioExecucaoFisica from "../pages/rag/relatorios/relatorioexecfisica";
import RelatorioApuracaoIndicador from "../pages/rag/relatorios/relatorioapuracaoindicador";
import RelatorioPendencia from "../pages/rag/relatorios/relatoriopendencia";
import RagCadastroExercicios from "../pages/rag/exercicios";
import Cronograma from "../pages/rag/exercicios/cronograma";
import RelatorioPermissaoRag from "../pages/rag/relatorios/RelatorioPermissaoRag";
import RelatorioAnaliseDevolutiva from "../pages/rag/relatorios/relatorioanalisedevol";
import RelatorioBaseGeralPrograma from "../pages/rag/relatorios/RelatorioBaseGeralPrograma";
import RelatorioOdsPublicoTransversal from "../pages/rag/relatorios/relatorioodspublicotransv";
import RelatorioExecucaoOrcamentariaAcao from "../pages/rag/relatorios/relatorioexecucaoorcamentariaacao";
import RelatorioBaseGeralAcao from "../pages/rag/relatorios/RelatorioBaseGeralAcao";
import RelatorioApuracaoIndicadorProgramaAcao from "../pages/rag/relatorios/RelatorioApuracaoIndicadorProgramaAcao";
import RelatorioProrrogacao from "../pages/rag/relatorios/RelatorioProrrogacao";
import RelatorioSugestaoMelhoria from '../pages/rag/relatorios/RelatorioSugestaoMelhoria';

const Router = () => {
  return (
    <>
      <Route path="/" exact component={BemVindo} />
      <Route path="/EmptyPage" exact component={EmptyPage} />

      <Route path="/usuarios" exact component={Usuarios} />
      <Route path="/usuario" exact component={Usuario} />
      <Route path="/usuario/perfil" exact component={PerfilUsuario} />

      <RouteWrapper path="/monlancamentos" exact component={MonitoraLancamentos} routePerfil={"lancamentos"} />
      <RouteWrapper path="/monpermissoes" exact component={MonitoraPermissoes} routePerfil={"permissaoUsuario"} />
      <RouteWrapper
        path="/exercicio"
        exact
        component={MonitoraCadastroExercicios}
        routePerfil={"cadastroExercicioPTAMonitora"}
      />
      <RouteWrapper
        path="/exercicio/ciclo/:id?"
        component={CadastroCiclo}
        routePerfil={"cadastroExercicioPTAMonitora"}
      />
      <RouteWrapper
        path="/relatoriopermissoes"
        exact
        component={RelatorioPermissoes}
        routePerfil={"relatorioPermissoes"}
      />
      <RouteWrapper
        path="/relatoriorestricaoitensmonitoraveis"
        exact
        component={RelatorioRestricaoItensMonitoraveis}
        routePerfil={"relatorioRestricaoItensMonitoraveis"}
      />
      <RouteWrapper
        path="/relatorioexecfisicasintetico"
        exact
        component={RelatorioExecucaoFisicaSintetico}
        routePerfil={"relatorioExecFisicaSintetico"}
      />
      <RouteWrapper
        path="/relatorioexecfisicaanalitico"
        exact
        component={RelatorioExecucaoFisicaAnalitico}
        routePerfil={"relatorioExecFisicaAnalitico"}
      />
      <RouteWrapper
        path="/relatoriofinanceirosinteticoacao"
        exact
        component={RelatorioExecucaoFinanceiraSintetico}
        routePerfil={"relatorioFinaceiroSinteticoAcao"}
      />

      <RouteWrapper
        path="/relatorioindicadoresacao"
        exact
        component={RelatorioIndicadoresAcao}
        routePerfil={"relatorioIndicadoresAcao"}
      />

      <RouteWrapper
        path="/relatoriofinanceiroanalitico"
        exact
        component={RelatorioExecucaoFinanceiraAnalitico}
        routePerfil={"relatorioFinanceiroAnalitico"}
      />
      <RouteWrapper
        path="/relatoriobasegeral"
        exact
        component={RelatorioBaseGeral}
        routePerfil={"relatorioBaseGeral"}
      />
      <RouteWrapper
        path="/relatoriostatusexecucao"
        exact
        component={RelatorioStatusExecucao}
        routePerfil={"relatorioStatusExecucao"}
      />
      <RouteWrapper
        path="/relatoriomonitoraconsolidado"
        exact
        component={RelatorioConsolidadoMonitoramento}
        routePerfil={"relatorioMonitoraConsolidado"}
      />

      <RouteWrapper path="/raglancamentos" exact component={RagLancamentos} routePerfil={"lancamentoRag"} />
      <RouteWrapper path="/avaliacao/acao" exact component={AvaliacaoAcaoRag} routePerfil={"lancamentoRag"} />
      <RouteWrapper path="/avaliacao/programa" exact component={AvaliacaoProgramaRag} routePerfil={"lancamentoRag"} />
      <RouteWrapper path="/ragpermissoes" exact component={RagPermissoes} routePerfil={"permissaoLancamentoRag"} />
      <RouteWrapper
        path="/relatorioconsolidado"
        exact
        component={RelatorioConsolidado}
        routePerfil={"relatorioAnalitico"}
      />
      <RouteWrapper
        path="/relatorioconsolidadoprogacao"
        exact
        component={RelatorioConsolidadoPorProgramaAcao}
        routePerfil={"relatorioAnaliticoProgramaAcao"}
      />
      <RouteWrapper
        path="/relatorioexecorcamentaria"
        exact
        component={RelatorioExecucaoOrcamentaria}
        routePerfil={"relatorioExecucaoOrcamentaria"}
      />
      <RouteWrapper
        path="/relatorio-base-geral-programa"
        exact
        component={RelatorioBaseGeralPrograma}
        routePerfil={"RelatorioBaseGeralPrograma"}
      />
      <RouteWrapper
        path="/relatorio-base-geral-acao"
        exact
        component={RelatorioBaseGeralAcao}
        routePerfil={"RelatorioBaseGeralAcao"}
      />
      <RouteWrapper
        path="/relatorio-sugestao-melhoria"
        exact
        component={RelatorioSugestaoMelhoria}
        routePerfil={"RelatorioSugestaoMelhoria"}
      />

      <RouteWrapper
        path="/relatorio-prorrogacoes"
        exact
        component={RelatorioProrrogacao}
        routePerfil={"RelatorioProrrogacao"}
      />
      <RouteWrapper
        path="/relatorio-apuracao-indicador-programa-acao"
        exact
        component={RelatorioApuracaoIndicadorProgramaAcao}
        routePerfil={"RelatorioApuracaoIndicadorProgramaAcao"}
      />
      <RouteWrapper
        path="/relatorioexecfisica"
        exact
        component={RelatorioExecucaoFisica}
        routePerfil={"relatorioExecucaoFisicaProdutoAcao"}
      />
      <RouteWrapper
        path="/relatorioapuracaoindicador"
        exact
        component={RelatorioApuracaoIndicador}
        routePerfil={"relatorioApuracaoIndicadorPrograma"}
      />
      <RouteWrapper
        path="/relatoriopendencia"
        exact
        component={RelatorioPendencia}
        routePerfil={"relatorioPendencia"}
      />
      <RouteWrapper
        path="/relatoriopermissao"
        exact
        component={RelatorioPermissaoRag}
        routePerfil={"relatorioPermissaoRag"}
      />
      <RouteWrapper
        path="/relatorioanalisedevol"
        exact
        component={RelatorioAnaliseDevolutiva}
        routePerfil={"relatorioAnaliseDevolutiva"}
      />
      <RouteWrapper
        path="/relatorioodspublico"
        exact
        component={RelatorioOdsPublicoTransversal}
        routePerfil={"relatorioOdsPublicoTransversal"}
      />
      <RouteWrapper
        path="/relatorioexecorcamacao"
        exact
        component={RelatorioExecucaoOrcamentariaAcao}
        routePerfil={"relatorioExecucaoOrcamentariaAcao"}
      />
      <RouteWrapper path="/ragexercicios" exact component={RagCadastroExercicios} routePerfil={"ExercicioRag"} />
      <RouteWrapper path="/ragexercicios/listaCronograma/:id?" component={Cronograma} routePerfil={"ExercicioRag"} />

      <Route path="" />
    </>
  );
};
export default Router;
